/** @type {import('tailwindcss').Config} */
import defaultTheme from 'tailwindcss/defaultTheme';
import forms from '@tailwindcss/forms';

export default {
    darkMode: ['class'],
    content: ['./src/**/*.{js,jsx,ts,tsx}'],
    theme: {
        extend: {
            fontFamily: {
                sans: ['Inter var', ...defaultTheme.fontFamily.sans],
            },
            keyframes: {
                nope: {
                    '0%': { transform: 'translateX(0)' },
                    '15%': { transform: 'translateX(12px)' },
                    '30%': { transform: 'translateX(-12px)' },
                    '45%': { transform: 'translateX(8px)' },
                    '60%': { transform: 'translateX(-8px)' },
                    '75%': { transform: 'translateX(4px)' },
                    '90%': { transform: 'translateX(-4px)' },
                    '100%': { transform: 'translateX(0)' },
                },
            },
            animation: {
                nope: 'nope 0.55s cubic-bezier(0.5, 1, 0.89, 1) forwards',
            },

            boxShadow: {
                indigo: '0 5px 15px -5px rgba(99, 114, 252, 0.4)',
                indigosm: '0 3px 8px -3px rgba(99, 114, 252, 0.3)',
                indigoxs: '0 1px 5px -1px rgba(99, 114, 252, 0.3)',
                indigoactive: '0 5px 20px -5px rgba(99, 114, 252, 0.6)',
                red: '0 5px 15px -5px rgba(252, 99, 99, 0.4)',
                redsm: '0 3px 8px -3px rgba(252, 99, 99, 0.3)',
                redxs: '0 1px 5px -1px rgba(252, 99, 99, 0.3)',
                redactive: '0 5px 20px -5px rgba(252, 99, 99, 0.6)',
                longshadow:
                    '1.369px 2.739px 6.162px 0px rgba(0, 0, 0, 0.10), 4.793px 10.27px 10.955px 0px rgba(0, 0, 0, 0.09), 10.955px 22.594px 15.063px 0px rgba(0, 0, 0, 0.05), 19.856px 39.711px 17.802px 0px rgba(0, 0, 0, 0.01), 30.811px 62.306px 19.171px 0px rgba(0, 0, 0, 0.00)',
            },
            screens: {
                '3xl': '1900px',
            },
            scale: {
                101: '1.01',
            },
            colors: {
                'text-grey': '#66738F',
                'text-dark': '#293C64',
                'ar-indigo': '#6574FD',
                'gradient-ar-indigo-from': '#6F7DFF',
                'gradient-ar-indigo-to': '#5D6DFA',
                'ar-red': '#FC6565',
                'gradient-ar-red-from': '#FF6F6F',
                'gradient-ar-red-to': '#FA5D5D',
            },
            borderRadius: {
                lg: 'var(--radius)',
                md: 'calc(var(--radius) - 2px)',
                sm: 'calc(var(--radius) - 4px)',
            },
        },
    },
    plugins: [forms],
    safelist: [
        {
            pattern: /(bg|text|border|gradient|from)-ar-(indigo|red)/,
        },
    ],
};
